import {useEffect, DependencyList, EffectCallback} from 'react';
import {useOriginalDeepCopy} from '@huse/previous-value';

const useDeepCompareEffect = (effect: EffectCallback, deps?: DependencyList | undefined): void => {
    const originalDeps = useOriginalDeepCopy(deps);

    useEffect(effect, originalDeps);
};

export default useDeepCompareEffect;